var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"home"}},[_c('div',{staticClass:"utilities"},[(_vm.user.is_superuser)?_c('admin'):_vm._e(),(_vm.user.is_staff)?_c('agenda'):_vm._e()],1),(_vm.user.is_staff)?_c('booking-list'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }